import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Config } from '../models/config';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentLoaderService {
  private appConfig: Config;

  constructor(private http: HttpClient) {
    this.appConfig = new Config();
  }

  get config(): Config {
    return this.appConfig;
  }

  load(): Promise<any> {
    const promise = this.http
      .get('assets/json/runtime.json?' + Date.now())
      .toPromise()
      .then((settings: Config | undefined) => {
        if (settings === undefined) {
          console.log(
            'Error loading runtime.json - using environment file instead'
          );
          this.appConfig = environment;
          return this.appConfig;
        }
        this.appConfig = settings;
        return this.appConfig;
      })
      .catch((error) => {
        console.log(
          'Error loading runtime.json - using environment file instead'
        );
        this.appConfig = environment;
        return this.appConfig;
      });

    return promise;
  }
}
